import { render, staticRenderFns } from "./_folder_tag_manager.vue?vue&type=template&id=8e28d132&"
import script from "./_folder_tag_manager.vue?vue&type=script&lang=js&"
export * from "./_folder_tag_manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports